module.exports = __webpack_public_path__ + "static/media/chanel.7f0c7cc5.svg";